<template>
  <div>...</div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["getActiveUser"]),
  },
  mounted() {
    const departmentId = this.getActiveUser.userInfo?.departmentInfo?.id;
    console.log(departmentId);
    console.log(this.getActiveUser);
    this.$router.push({
      name: "department-detail",
      params: { departmentId },
    });
  },
};
</script>

<style></style>
